import React, { Component } from 'react'

class Screen3 extends Component {

  render() {

    const { entry, addEntry, setAnonymous, screenAlert, language, t } = this.props

    const popup = <div className="popup">
        <p>{t(language, 'noEmail')}</p>
        <p>{t(language, 'canSubmitAnonymous')}</p>
        <p>{t(language, 'noEmailFeedback')}</p>
        <button onClick={setAnonymous}>&#10005;</button>
      </div>

    return (
      <main>
        <h3>{entry.form}</h3>
        <p style={{ marginBottom: 10 }}>{t(language, 'contactInfo')}</p>
        <p style={{ marginBottom: 36 }}>{t(language, 'anonymousNote')}</p>
        <label>{t(language, 'emailOptional')}
          <input type="text" value={entry.email} onChange={(e) => addEntry('email', null, e)} />
        </label>
        <label>{t(language, 'nameAlias')}
          <input type="text" value={entry.alias} onChange={(e) => addEntry('alias', null, e)} />
        </label>
        {screenAlert === 3 ? popup : null}
      </main>
    );
  }
}

export default Screen3;
